import React from "react";

const SelectedPages = React.createContext({});

export const SelectedPagesProvider = SelectedPages.Provider;
export default SelectedPages;
